// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Plus = ({ width, height, color }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '100%'}
    height={height || '100%'}
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(2 2)">
      <path
        fill={color || 'currentColor'}
        d="M10.551 9.444V5.556a.556.556 0 0 0-1.111 0v3.888H5.556a.556.556 0 0 0 0 1.112H9.44v3.888a.556.556 0 0 0 1.111 0v-3.888h3.893a.556.556 0 0 0 0-1.112h-3.893zM10 19c-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9 4.963 0 9 4.038 9 9 0 4.963-4.037 9-9 9m0-19C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0"
      />
    </g>
  </svg>
);
